<template>
    <li>
      <div :class="nodeClassComputed">
        <div :class="itemClassComputed" v-popover:popover>
            <div class="tg-tree-card--header id" :title="userfullname">
                <span>{{userfullname}}</span>
            </div>
            <div class="tg-tree-card--content">
                <div class="flex-row">
                    <span class="actor"></span>
                    <div class="flex-column">
                        <template v-if="is_tgbusiness || item.group > 10">
                            <p
                                v-if="item.total_tg_business_num"
                                :title="$t('component.tree.total_tg_business_num', {value: toThousand(item.total_tg_business_num)})"
                            >
                                <strong>{{$t('component.tree.total_tg_business_num', {value: parseNumberToSort(item.total_tg_business_num)})}}</strong>
                            </p>
                            <p
                                v-if="item.total_tg_num"
                                :title="$t('component.tree.total_tg_num', {value: toThousand(item.total_tg_num)})"
                            >{{$t('component.tree.total_tg_num', {value: parseNumberToSort(item.total_tg_num)})}}</p>
                            <p
                                v-if="item.directpush_num"
                                :title="$t('component.tree.directpush_num', {value: toThousand(item.directpush_num)})"
                            >{{$t('component.tree.directpush_num', {value: parseNumberToSort(item.directpush_num)})}}</p>
                            <p
                                v-if="item.parent_name && item.group > 10"
                                :title="$t('component.tree.info.parent_name', {value: item.parent_name})"
                            >{{$t('component.tree.info.parent_name', {value: item.parent_name})}}</p>
                        </template>
                        <template v-else>
                            <p v-if="item.parent_name">{{$t('component.tree.parent_name')}}{{item.parent_name}}</p>
                        </template>
                    </div>
                </div>
                <template v-if="showFinanceInfo">
                    <div class="tg-tree-card--content--sub">
                      <template v-for="(column, i) in columns">
                        <p :key="i">{{$t(column.langKey)}}：{{ column.format ? formatValue(column.format, item[column.name]) : item[column.name]}}</p>
                      </template>
                    </div>
                </template>
            </div>
            <div class="tg-tree-card--footer">
                <i v-show="is_tgbusiness"></i>
                <span v-if="is_tgbusiness && item.member_level" style="margin-right: 3px;">Lv.{{item.member_level}}</span>
                <span>
                    {{$t('column.l' + item.group)}}
                </span>
            </div>
        </div>
  
        <el-popover
          v-show="is_tgbusiness"
          ref="popover"
          placement="right-start"
          width="200"
          :offset="10"
          v-model="visibleInfo"
          popper-class="tg-tree-item--info"
          @show="handleInfoClick"
        >
          <tg-tree-info :info="info" :isDel="item.is_del"></tg-tree-info>
        </el-popover>
        <button type="button" :class="buttonClass" @click="handleClick" :disabled="disabledComputed"></button>
      </div>
      <template v-if="item.children && item.children.length > 0">
        <ul :class="childrenClass" v-show="showChildren" @scroll="handleScroll">
          <template v-for="(sub, i) in item.children">
            <tg-tree-card
              v-if="!(sub.is_del==1 && sub.is_tgbusiness == 0)"
              :key="i"
              :item="sub"
              :level="level + 1"
              :expandAll="expandAll"
              @on-toggle="$emit('on-toggle', $event)"
              @on-info-click="$emit('on-info-click', $event)"
              :columns=columns
            />
          </template>
        </ul>
      </template>
    </li>
  </template>
  
  <script>
  import TgTreeInfo from "@/components/tree/TgTreeInfo";
  import formatter from "@/utils/formatter";
  
  export default {
    name: "TgTreeCard",
    components: {
      TgTreeInfo,
    },
    data() {
      return {
        status: false,
        disabled: false,
        visibleInfo: true,
        info: {},
        loading: false,
        hasNextPage: true,
      };
    },
    inject: ["tree", "nodes"],
    props: {
      item: Object,
      nodeClass: [String, Array, Object],
      itemClass: [String, Array, Object],
      level: {
        type: Number,
        default() {
          return 1;
        },
      },
      expand: Boolean,
      expandAll: Boolean,
      columns: Array
    },
    computed: {
      showFinanceInfo() {
        console.log(this.columns);
        return this.columns && this.columns.length > 0
      },
      itemClassComputed() {
        let group = this.itemComputed.group;
        let is_tgbusiness = this.is_tgbusiness;
        let onlyTGmember =
          !this.item.total_tg_business_num ||
          this.item.total_tg_business_num == 0;
        let classes = [
          "tg-tree-card",
          {
            // "level-icon--first": group == 80,
            // "level-icon--second": group == 70,
            // "level-icon--third": group == 60,
            // "level-icon--fourth": group == 40,
            // "level-icon--fifth": group == 20,
            // // "level-icon--sixth": this.group == 6,
            "level-icon--member": group == 10,
            tg: is_tgbusiness == 0,
            micronet: is_tgbusiness == 1,
            // "level-icon--expand-all": this.expandAll
            "level-icon--manager": group > 10,
            onlyTGmember: group > 10 && onlyTGmember,
            haveMicronet: group > 10 && !onlyTGmember,
          },
        ];
  
        if (!Array.isArray(this.nodeClass)) {
          classes.push(this.nodeClass);
        } else {
          classes = classes.concat(this.nodeClass);
        }
  
        return classes;
      },
      nodeClassComputed() {
        let classes = ["tg-tree--node", "tg-tree--node-" + this.level];
  
        if (!Array.isArray(this.nodeClass)) {
          classes.push(this.nodeClass);
        } else {
          classes = classes.concat(this.nodeClass);
        }
  
        return classes;
      },
      childrenClass() {
        return ["tg-tree-level--" + (this.level + 1)];
      },
      buttonClass() {
        return [
          "button",
          {
            expand: this.status,
          },
        ];
      },
      showChildren() {
        return this.status;
      },
      itemComputed() {
        return this.item;
      },
      disabledComputed() {
        if (this.item.isTop) {
          return true;
        }
  
        // if (
        //   this.itemComputed.checked &&
        //   (!this.itemClassComputed.children ||
        //     this.itemClassComputed.children.length == 0)
        // ) {
        //   return true;
        // }
  
        return this.disabled;
      },
      is_tgbusiness() {
        return this.itemComputed.is_tgbusiness == 1;
      },
      userfullname() {
        let fullname = this.item.username;
  
        if (this.is_tgbusiness) {
          if (this.item.tg_business_nickname) {
            fullname += "(" + this.item.tg_business_nickname + ")";
          }
        } else if (this.item.usernickname) {
          fullname += "(" + this.item.usernickname + ")";
        }
        return fullname;
      },
      total_tg_business_num() {
        return this.parseNumberToSort(this.item.total_tg_business_num);
      },
    },
    created() {
      this.status = this.expand;
      this.visibleInfo = false;
    },
    mounted() {
      if (this.item) {
        this.nodes[this.item.username] = this;
      }
    },
    methods: {
      toThousand(value) {
        return formatter.format(value, "thousand");
      },
      parseNumberToSort(value) {
        let num = this.toThousand(value);
        let values = num.split(",");
  
        let unit = ["", "k", "m"];
        return values[0] + unit[values.length - 1];
      },
      handleInfoClick() {
        if (!this.is_tgbusiness) {
          this.visibleInfo = false;
          return;
        }
  
        let event = { item: this.itemComputed };
        this.$emit("on-info-click", event);
  
        if (!event.fetch) {
          this.visibleInfo = false;
        }
  
        event.fetch.then((info) => {
          this.info = info;
        });
      },
      handleItemClick() {
        if (this.is_tgbusiness) {
          this.visibleInfo = true;
        }
      },
      handleClick(clickEvent) {
        let event = { clickEvent, status: !this.status, item: this.itemComputed };
  
        if (this.expandAll && !event.status) {
          this.status = event.status;
          return;
        }
  
        this.$emit("on-toggle", event);
  
        if (event.prevent || !event.done) {
          this.status = event.status;
          return;
        }
  
        event.done.then((e) => {
          this.itemComputed.checked = true;
  
          if (e.status) {
            if (e.item.children && e.item.children.length > 0) {
              this.itemComputed.children = e.item.children;
              this.status = e.status;
            } else {
              this.disabled = true;
              this.status = !e.status;
            }
          }
        });
      },
      handleScroll(e) {
        let target = e.target;
        let point = target.clientWidth + target.scrollLeft;
        let trigger = point * 100 / target.scrollWidth;
  
        if (trigger >= 90) {
          this.$emit('on-scroll', e);
        }
        
      },
      formatValue(format, value) {
        return formatter.format(value, format);
      }
    },
    watch: {
      expand(value) {
        this.status = value;
      },
      item() {
        // in all 資料更新 關閉展開
        this.$nextTick(() => {
          if (this.expandAll) {
            this.status = this.level == 1 ? true : false;
          } else {
            // not all 僅第一層展開
            this.status = this.level == 1;
          }
          this.disabled = false;
        });
      },
      expandAll(value) {
        this.$nextTick(() => {
          if (value) {
            this.status = this.level == 1 ? true : false;
          } else {
            this.status = this.level == 1;
          }
          this.disabled = false;
        });
      },
    },
  };
  </script>